// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Locale$LumiI18n from "./Locale.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function MakeProvider(P) {
  let translate = (locale, entry) => {
    let initTranslation = P.translate(locale, entry);
    let defaultLocale = P.defaultLocale;
    let translation = defaultLocale !== undefined && defaultLocale !== locale ? Stdlib_Option.orElse(initTranslation, P.translate(defaultLocale, entry)) : initTranslation;
    return Stdlib_Option.getOr(translation, "⚠ no translation ⚠");
  };
  let string = translate;
  let Translation$MakeProvider$Text = props => {
    let locale = Locale$LumiI18n.useContext();
    return translate(locale, props.entry);
  };
  let Text = {
    string: string,
    make: Translation$MakeProvider$Text
  };
  let Translation$MakeProvider$Label = props => {
    let locale = Locale$LumiI18n.useContext();
    return JsxRuntime.jsx("label", {
      children: translate(locale, props.entry),
      className: "label"
    });
  };
  let Label = {
    make: Translation$MakeProvider$Label
  };
  return {
    mbTranslate: P.translate,
    translate: translate,
    Text: Text,
    Label: Label
  };
}

export {
  MakeProvider,
}
/* Locale-LumiI18n Not a pure module */
